import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppTheme, PrestoAppComponents, PrestoAppUtils } from 'presto-mini-apps-lib';
import PageWrapper from '../../components/PageWrapper';
import {
    ButtonHeight,
    ContainerWidth,
    setupPinSuccessLogo,
    topUpFailedLogo,
    topUpSuccessLogo
} from '../../constants/appState';
import {
    phrase_PINNotNotMatch,
    term_confirm,
    term_ok,
} from '../../constants/text';
import connectPage from '../../scenes/Main/index';
import Routes from '../../constants/routes';
import { appService } from '../../services';
import DigitInputWithLabel from '../../components/DigitInputWithLabel';
import { ErrorCode } from '../../constants/statusCode';


class TransactionPin extends Component {
    pageName;

    constructor(props) {
        super(props);

        this.pageName = Routes.TXN_PIN;
        this.pinNumberInput = null;
        this.confirmPinNumberInput = null;

        this.state = {
            step: 1,
            withBackButton: true,
            formValue: {
                pinNumber: '',
                confirmPinNumber: '',
                pinNumberError: false,
            },
            clearField: false,
            clearFieldStep2: false,
            confirmDisabled: true,
            confirmStep2Disabled: true,
            success: false,
        }
    }

    componentDidMount() {
        if (this.pinNumberInput) {
            this.pinNumberInput.clear();
            this.pinNumberInput.focus();
        }
    }

    onGoToPayment = () => {
        const { actionHandler } = this.props;
        
        actionHandler.changePageHandler(Routes.PAYMENT);
    };

    onPinNumberChangeHandler = (val) => {
        this.setState({
            formValue: {
                ...this.state.formValue,
                pinNumber: val,
            },
            confirmDisabled: (val && val.length < 6)
        });
    };

    onConfirmPinNumberChangeHandler = (val) => {
        this.setState({
            formValue: {
                ...this.state.formValue,
                confirmPinNumber: val,
                pinNumberError: false,
            },
            confirmStep2Disabled: (val && val.length < 6),
        });
    };

    onConfirmed = () => {
        this.setState({
            step: 2
        }, () => {
            if (this.confirmPinNumberInput) {
                this.confirmPinNumberInput.focus();
            }
        });
    }

    onStep2Confirmed = () => {
        const { actionHandler, mainProps } = this.props;
        const loginData = mainProps.appState.loginData;

        const { formValue } = this.state;
        if (formValue.pinNumber !== formValue.confirmPinNumber) {
            this.setState({
                formValue: {
                    ...this.state.formValue,
                    pinNumberError: (formValue.pinNumber && formValue.confirmPinNumber.length)
                },
                confirmStep2Disabled: true,
            });

            return;
        }

        actionHandler.setIsLoading(true);
        appService.apiTxnPinUpdate({
            paymentCode: window.PrestoPayObj.paymentCode,
            loginMethod: loginData.loginMethod,
            mobileNum: loginData.mobile,
            mobileCountryCode: loginData.mobileCountryCode,
            email: loginData.email,
            password: loginData.password,
            authCode: window.PrestoPayObj.authCode,
            txnPin: formValue.pinNumber,
            confirmTxnPin: formValue.confirmPinNumber,
            onSuccess: this.onSubmitSuccessHandler,
            onError: this.onSubmitFailedHandler,
        });
        
    }

    onSubmitSuccessHandler = (resp) => {
        const { actionHandler, mainProps } = this.props;
        const { paymentData } = mainProps.appState;

        actionHandler.setIsLoading(false);
        if (!!resp.success) {
            this.setState({
                step: 3,
                withBackButton: false,
                success: resp.data.success,
            });
            
            // Update requireOtp
            actionHandler.updatePaymentData({
                ...paymentData,
                requireOtp: resp.data.success ? false : true,
            });
        }
    };

    onSubmitFailedHandler = (data) => {
        const {
            actionHandler,
        } = this.props;

        actionHandler.setIsLoading(false);

        switch (+data.errorCode) {
            case ErrorCode.CONFIRM_PIN_NOT_MATCH:
                this.setState({
                    formValue: {
                        ...this.state.formValue,
                        pinNumberError: true,
                    },
                    confirmStep2Disabled: true,
                });
                break;
            default:
                this.setState({
                    step: 3,
                    success: false,
                });
        }
    };

    render() {
        const { formValue, step, confirmDisabled, confirmStep2Disabled, success, withBackButton } = this.state;

        return (
            <React.Fragment>
                <PageWrapper withBackButton={withBackButton} containerHeight={300}>
                    <TransactionPinWrapper className="transaction-pin">
                        {step === 1 && (
                            <div className="step-1 step">
                                <div className="title">
                                    <div className="label">Secure Your Account with a</div>
                                    <div className="label">PIN code</div>
                                </div>
                                <div className="form">
                                    <div className="label">Set up your PIN code now to secure your account, and enjoy a more convenient login and payment process on Presto.</div>
                                    <div className="pin-input">
                                        <DigitInputWithLabel
                                            ref={n => (this.pinNumberInput = n)}
                                            initialValue=""
                                            length={6}
                                            inputName="pinNumber"
                                            type="password"
                                            onChange={this.onPinNumberChangeHandler}
                                        />
                                    </div>
                                </div>
                                <SuccessActionWrapper>
                                    <div className="action-area">
                                        <PrestoAppComponents.Button
                                            height={ButtonHeight + 'px'}
                                            className="confirmed-button"
                                            onClick={this.onConfirmed}
                                            disabled={confirmDisabled}
                                        >{term_confirm}</PrestoAppComponents.Button>
                                    </div>
                                </SuccessActionWrapper>
                            </div>
                        )}
                        {step === 2 && (
                            <div className="step-2 step">
                                <div className="title">
                                    <div className="label">Re-enter PIN code</div>
                                </div>
                                <div className="form">
                                    <div className="label">Please enter your PIN code again to complete the set up.</div>
                                    <div className="pin-input">
                                        <DigitInputWithLabel key="confirmPinNumber"
                                            ref={n => (this.confirmPinNumberInput = n)}
                                            initialValue=""
                                            length={6}
                                            inputName="confirmPinNumber"
                                            type="password"
                                            onChange={this.onConfirmPinNumberChangeHandler}
                                            errorMessage={phrase_PINNotNotMatch}
                                            isError={formValue.pinNumberError}
                                        />
                                    </div>
                                </div>
                                <SuccessActionWrapper>
                                    <div className="action-area">
                                        <PrestoAppComponents.Button
                                            height={ButtonHeight + 'px'}
                                            className="confirmed-button"
                                            onClick={this.onStep2Confirmed}
                                            disabled={confirmStep2Disabled}
                                        >{term_confirm}</PrestoAppComponents.Button>
                                    </div>
                                </SuccessActionWrapper>
                            </div>
                        )}
                        {step === 3 && (
                            <div className="step-3 step">
                                <div className="page-icon">
                                    <div className="icon-holder">
                                        <div className={success ? 'icon' : 'icon error'} />
                                    </div>
                                </div>
                                <div className="title">
                                    <div className="label">{success ? 'Transaction PIN Set Up Successful!' : 'Transaction PIN Set Up Failed!'}</div>
                                </div>
                                <div className="form">
                                    <div className="label">{success ? 'You may now use your PIN to login and make payments.' : 'Oops! Something went wrong. Please try again later.'}</div>
                                </div>
                                <SuccessActionWrapper>
                                    <div className="action-area">
                                        <PrestoAppComponents.Button
                                            height={ButtonHeight + 'px'}
                                            className="confirmed-button"
                                            onClick={this.onGoToPayment}
                                        >{term_ok}</PrestoAppComponents.Button>
                                    </div>
                                </SuccessActionWrapper>
                            </div>
                        )}
                    </TransactionPinWrapper>
                </PageWrapper>
            </React.Fragment>
        );
    }
}

export default connectPage(TransactionPin);

const iconWidth = "3.0rem";

const TransactionPinWrapper = styled.div`
    min-height: 100px;

    & .step {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: ${PrestoAppTheme.layout.largeGap};

        & .page-icon {
            position: relative;
            height: 140px;
            width: 140px;
            margin: ${PrestoAppTheme.layout.largeGap} auto;

            & .icon-holder {
                display: flex;
                position: absolute;
                bottom: 0;
                width: 100%;
                height: 100%;
                justify-content: center;
                align-items: center;

                & .icon {
                    height: 100%;
                    width: 100%;
                    background: url(${setupPinSuccessLogo}) center / contain no-repeat;

                    &.error {
                        background: url(${topUpFailedLogo}) center / contain no-repeat;
                    }
                }
            }
        }

        & .title {
            display: flex;
            align-items: center;
            flex-direction: column;

            & .label {
                text-align: center;
                font-size: ${PrestoAppTheme.layout.fontSizeStandard};
                font-weight: 500;
            }
        }

        & .form {
            display: flex;
            align-items: center;
            flex-direction: column;

            & .label {
                text-align: center;
                margin: ${PrestoAppTheme.layout.largeGap} 0 ${PrestoAppTheme.layout.largeGap} 0;
            }

            & .pin-input {
                width: 100%;
            }
        }
    }
`;

const SuccessActionWrapper = styled.div`
    position: relative;
    width: 100%;
    max-width: ${ContainerWidth}px;
    margin: ${PrestoAppTheme.layout.commonGap} 0;

    & .action-area {
        padding: 0;

        & .confirmed-button {
            &[disabled] {
                background-color: rgba(${PrestoAppTheme.colors.prestoRedRGB}, .4);
            }
        }
    }
`;